import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EventqScheduleEntry } from '../schedule-entry/schedule-entry';

export interface EventqScheduleListEntry {
  id: string;
  title?: string | null;
  days: string;
  time: string;
}

const DEFAULT_SKELETON_COUNT = 3;

/** Figma Other Schedules column (7781:106798 / 7781:106897 / 7781:106993). */
@Component({
  selector: 'eventq-schedule-list',
  imports: [EventqScheduleEntry],
  templateUrl: './schedule-list.html',
  styleUrl: './schedule-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqScheduleList {
  readonly heading = input.required<string>();
  readonly entries = input.required<readonly EventqScheduleListEntry[]>();
  readonly emptyLabel = input('No schedules');
  readonly loading = input(false, { transform: booleanAttribute });
  readonly skeletonCount = input<number | null>(null);
  readonly calendarIconSrc = input.required<string>();
  readonly clockIconSrc = input.required<string>();

  readonly skeletonIndexes = computed(() => {
    const explicit = this.skeletonCount();
    const count =
      explicit != null && explicit > 0 ? explicit : DEFAULT_SKELETON_COUNT;
    return Array.from({ length: count }, (_, index) => index);
  });

  readonly isEmpty = computed(() => this.entries().length === 0);
}
